
import { injectPrimitive } from "../../../../../common/store/base/injectPrimitive";
import { IPrimitiveStore } from "../../../../../common/store/interface/IPrimitiveStore";
import { saveFileInBrowser } from "../../../../../common/utils/saveFileInBrowser";
import { IProjectLearningReportArg } from "../../../../../service/report/interface/IProjectLearningReportArg";
import { IFullStudyReportDomain } from "./IFullStudyReportDomain";
import { IStudyReportNavbarUI } from "./IStudyReportNavbarUI";

const REPORT_FILE_TYPE = "csv";

const formatDateForFileName = (d = new Date()) => {
  const yyyy = String(d.getFullYear());
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const createUnitsReportFileName = (type: string, d = new Date()) =>
  `report_units-${formatDateForFileName(d)}.${type}`;

const createEmployeesReportFileName = (type: string, d = new Date()) =>
  `report_employees-${formatDateForFileName(d)}.${type}`;

export class StudyReportNavbarUI implements IStudyReportNavbarUI {
  isFetching: IPrimitiveStore<boolean>;

  constructor(
    private fullStudyReportDomain: IFullStudyReportDomain,
    private reportArg: IProjectLearningReportArg = {},
  ) {
    this.isFetching = injectPrimitive(false);
  }

  exportUnitsReport = async () => {
    return this.downloadAndSave({
      fileName: createUnitsReportFileName(REPORT_FILE_TYPE),
      download: () =>
        this.fullStudyReportDomain.downloadReport({
          type: REPORT_FILE_TYPE,
          reportArg: this.reportArg,
        }),
    });
  };

  exportEmployeesReport = async () => {
    return this.downloadAndSave({
      fileName: createEmployeesReportFileName(REPORT_FILE_TYPE),
      download: () =>
        this.fullStudyReportDomain.downloadEmployeesReport({
          type: REPORT_FILE_TYPE,
          reportArg: this.reportArg,
        }),
    });
    
  };

  private downloadAndSave = async ({
    fileName,
    download,
  }: {
    fileName: string;
    download: () => Promise<Blob>;
  }) => {
    if (this.isFetching.value) return;

    this.isFetching.setValue(true);

    try {
      const blob = await download();
      saveFileInBrowser(fileName, blob);
    } finally {
      this.isFetching.setValue(false);
    }
  };
}
